const commentsData = [
  {
    name: '樱落无声',
    date: '3天前',
    content: '终于找到这么全的蜜桃动漫在线资源站了！羞羞动漫在线观看完整版收录太全了，校园恋爱系列一口气追完，画质也很清晰，强烈推荐给同好！',
    rating: 5,
    tag: '校园恋爱粉',
  },
  {
    name: '月下独酌',
    date: '5天前',
    content: '作为羞羞动漫在线老用户了，更新速度真的快，新番48小时就能看到。蜜桃动漫在线分类也很清晰，找片超方便，已经安利给身边所有朋友了。',
    rating: 5,
    tag: '追番达人',
  },
  {
    name: '风铃轻响',
    date: '1周前',
    content: '手机端体验非常棒，下拉式浏览很流畅，坐地铁的时候经常用羞羞动漫在线免费观看打发时间。希望奇幻冒险系列再多更新一些！',
    rating: 4,
    tag: '移动端用户',
  },
  {
    name: '星光璀璨',
    date: '2周前',
    content: '蜜桃动漫在线的资源质量没得说，高清播放不卡顿，也没有烦人的广告弹窗。羞羞动漫在线观看完整版体验一级棒，从老站转过来的，完全不后悔。',
    rating: 5,
    tag: '资深漫迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            漫友评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            听听羞羞动漫在线观看用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="p-5 bg-background-100/60 rounded-xl border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i
                    key={j}
                    className={`text-xs ${
                      j < comment.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 text-xs font-bold">
                    {comment.name.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-700">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.date}</p>
                  </div>
                </div>
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-600 text-xs rounded-full">
                  {comment.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}